import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { SUPPORTED_CODES, RTL_LANGS } from "./languages";

// Non-English locale bundles are generated into ./locales/<code>.json by the
// translation script. English is the base: keys ARE the English strings.
i18n.use(initReactI18next).init({
  lng: "en",
  fallbackLng: "en",
  supportedLngs: SUPPORTED_CODES,
  resources: {},
  keySeparator: false,
  nsSeparator: false,
  interpolation: { escapeValue: false },
  returnNull: false,
  returnEmptyString: false,
});

const loaded = { en: true };

function applyDir(lng) {
  const dir = RTL_LANGS.includes(lng) ? "rtl" : "ltr";
  document.documentElement.setAttribute("dir", dir);
  document.documentElement.setAttribute("lang", lng);
}

export async function setLanguage(lng) {
  if (!SUPPORTED_CODES.includes(lng)) lng = "en";
  if (lng !== "en" && !loaded[lng]) {
    try {
      const mod = await import(`./locales/${lng}.json`);
      i18n.addResourceBundle(lng, "translation", mod.default || mod, true, true);
      loaded[lng] = true;
    } catch (e) {
      // No bundle yet -> fall back to English keys.
    }
  }
  await i18n.changeLanguage(lng);
  localStorage.setItem("lang", lng);
  applyDir(lng);
}

// Restore a previously chosen language on first load.
const saved = localStorage.getItem("lang");
if (saved && saved !== "en") setLanguage(saved);

export default i18n;
